<template>
  <text-box :label="`Spend & Variability by Segment (${unit})`" icon="segment">
    <template v-slot:info-dialog>
      Projected estimated {{ customKpiName }} contribution by media (ref. of 100% of TV {{ customKpiName }} contribution, which % will come from each segment)
      <br><br>
      Circled numbers show variability level (0-100%) for each dimension (the higher the number, the most discriminant the variable is for explaining {{ customKpiName }} contribution)
    </template>
    <v-container fluid>
      <v-row>
        <v-col cols="7"></v-col>
        <v-col cols="5">
          <v-select
            v-model="orderBy"
            :items="sortItems"
            menu-props="auto"
            label="Sort by"
            prepend-icon="mdi-sort"
            single-line
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          Media
        </v-col>
        <v-col cols="3" v-for="key in orderedSegmentKeys" :key="`seg_${key}`">
          {{ key }}
        </v-col>
      </v-row>
      <v-row :class="`${halfWidth ? 'pr-2' : ''}`">
        <v-col cols="3">
          <div style="padding-top: 25px;">
            <div>Total</div>
            <div style="font-size: 12px;">Spend: {{ formatValue(data.budget) }} (100%)</div>
          </div>
        </v-col>
        <v-col cols="3" v-for="key in orderedSegmentKeys" :key="`tot_${key}`">
          <segment-stacked-bar :data="data.segments[key]" />
        </v-col>
      </v-row>
      <v-row v-for="(channel, index) in orderedSpend" :key="channel.key" :class="`${halfWidth ? 'pr-2' : ''}`">
        <v-col cols="3">
          <div style="padding-top: 25px;">
            <div>{{ channel.key }}</div>
            <div style="font-size: 12px;">Spend: {{ formatValue(channel.invest) }} ({{ data.budget ? formatValue(100 * channel.invest/data.budget) : '0' }}%)</div>
          </div>
        </v-col>
        <v-col cols="3" v-for="key in orderedSegmentKeys" :key="`medium_seg_${key}`">
          <segment-stacked-bar :data="orderedSpend[index].segments[key]" />
        </v-col>
      </v-row>
    </v-container>
  </text-box>
</template>

<script>
import _ from 'lodash'
import numbro from 'numbro'
import SegmentStackedBar from '@/components/simulationDetails/SegmentStackedBar.vue'
import TextBox from '@/components/TextBox.vue'

export default {
  data () {
    return {
      orderBy: 'invest'
    }
  },
  computed: {
    sortItems: function () {
      let items = [{
        text: 'Media Spend',
        value: 'invest'
      }]
      for (var key in this.spend[0].segments) {
        items.push({
          text: key + ' Variability',
          value: key
        })
      }
      return items
    },
    spend: function () {
      let spend = []
      for (var key in this.data.mix) {
        spend.push({
          ...this.data.mix[key],
          key: key
        })
      }
      return spend
    },
    orderedSpend: function () {
      if (this.orderBy !== 'invest') {
        return _.orderBy(this.spend, `segments["${this.orderBy}"].variability`, 'desc')
      } else {
        return _.orderBy(this.spend, 'invest', 'desc')
      }
    },
    orderedSegmentKeys: function () {
      return Object.keys(this.data.segments).sort()
    }
  },
  methods: {
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      required: false
    },
    colsPerRow: {
      type: Number,
      required: false,
      default: function () {
        return 4
      }
    },
    unit: {
      type: String,
      required: false,
      default: function () {
        return 'USD'
      }
    },
    halfWidth: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    },
    customKpiName: {
      type: String,
      required: true
    }
  },
  components: {
    TextBox,
    SegmentStackedBar
  }
}
</script>
